import Glide from '@glidejs/glide'
export default {
  init() {
    // JavaScript to be fired on the home page


    $('#quitar-mute').on( 'click' , function (){
      if( $('video').prop('muted', true) )
      {
        console.log('vamso a poner el volumen');
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').on( 'click' , function (){

        if( $('video').prop('muted', false) ) {
          console.log('vamso quitar el volumen');
          $('video').prop('muted', true);
          $('#quitar-mute').css('display', 'block');
          $('#mute-video').css('display', 'none');
        }
    });


    $('.destacadoisGrid').on('mouseover', function(e){
      e.stopPropagation();
      $(this).find('.capaTextoDestacadoSubir').addClass( 'agrandar');
      $(this).find('.btngridDestacado').addClass( 'mostrar');
      $(this).find('.descGridDestacado').addClass( 'mostrar' );

    });

    $('.destacadoisGrid').on('mouseleave', function(e){
      e.stopPropagation();
      $(this).find('.btngridDestacado').removeClass( 'mostrar');
      $(this).find('.capaTextoDestacadoSubir').removeClass( 'agrandar');
      $(this).find('.descGridDestacado').removeClass( 'mostrar' );
    });

/*    $('.destacadoisGrid').on('mouseover', function(e){
      e.stopPropagation();
      $('.capaTextoDestacadoSubir', this).animate({
        height: '100%',
      }, 500, function (){
        $(this).addClass( 'agrandar');
        $(this).find('.btngridDestacado').addClass( 'mostrar');
        $(this).find('.descGridDestacado').addClass( 'mostrar' );
      } );


    });*/

    let glide = new Glide('.glide', {
      type: 'carousel',
      perView: 4,
      breakpoints: {
        400: {
          perView: 1,
        },
        600: {
          perView: 2,
        },
        990: {
          perView: 3,
        },
        1200: {
          perView: 3,
        },
        1600: {
          perView: 4,
        },
      },
    });
    glide.mount();

    let glideDest = new Glide('.glideDestacados', {
      type: 'slider',
      perView: 5,
      bound: true,
      startAt: 0,
      breakpoints: {
        400: {
          perView: 1,
        },
        600: {
          perView: 2,
        },
        990: {
          perView: 3,
        },
        1200: {
          perView: 4,
        },
        1600: {
          perView: 5,
        },
      },
    });
    glideDest.mount();







  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js